import { NavbarService } from './../../core/services/navbar.service';
import { AccountService } from './../../core/services/account.service';
import { Router } from '@angular/router';
import {
  MoviePurchaseBody,
  SuscriptionPurchaseBody,
  DeployPurchase,
  PurchaseResponseModel,
  InfoPurchase,
  RedeemSuscriptionBody,
} from './../../core/interfaces/purchase.model';
import { TYPE_TRANSACTION } from './../../core/Utils/global';
import { Component, Input, NgZone, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AuthService } from 'src/app/core/auth/auth.service';
import { PaymentInfo, PaymentProfile } from 'src/app/core/interfaces/purchase.model';
import { PWCheckoutLoaderService } from 'src/app/core/services/pwcheckout.service';
import { TransactionsService } from 'src/app/core/services/transactions.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { FormControl, FormGroup, Validators } from '@angular/forms';

declare var PWCheckout: any;

@Component({
  selector: 'app-payment-options',
  templateUrl: './payment-options.component.html',
  styleUrls: ['./payment-options.component.css'],
})
export class PaymentOptionsComponent implements OnInit, OnChanges {
  @Input() typeTransaction: TYPE_TRANSACTION = null;
  @Input() objetoPurchase: DeployPurchase = null;
  @Input() info: InfoPurchase = null;
  @Input() ppv: boolean = false;

  listaTarjetas: Array<PaymentProfile> = [];
  tokenID: string;
  uniqueID: string;
  purchaseID: number;
  currentPayment: PaymentProfile;
  tarjetaSeleccionada;

  couponForm: FormGroup;

  cargandoTarjetas = false;
  cargandoPago = false;
  botonPagoDisabled = false;

  PWCheckout_Properties = {
    name: 'Ingreso de tarjeta',
    image: `${environment.hostName}/assets/img/logos_cinemateca/Logo completo negro.png`,
    email: this.auth.getEmail(),
    description: '',
    currency: 'UYU',
    lang: 'ESP',
    form_id: 'payment_form',
    checkout_card: 1,
    autoSubmit: 'false',
    email_edit: 'false',
  };

  ngOnInit(): void {
    this.loadSiemprePagoJavascript();
    this.cargarTarjetas();
  }

  constructor(
    private router: Router,
    private accountService: AccountService,
    private auth: AuthService,
    private transactionsService: TransactionsService,
    private navbarService: NavbarService,
    private _pwCheckout: PWCheckoutLoaderService,
    private _ngZone: NgZone,
  ) {
    this.couponForm = new FormGroup({
      codigoCupon: new FormControl('', [Validators.required]),
    });
  }

  realizarPago() {
    if (this.uniqueID) {
      this.cargandoPago = true;
      let bodyPurchase: MoviePurchaseBody | SuscriptionPurchaseBody;

      // PAGAR SUSCRIPCION
      if (this.typeTransaction == 'suscription') {
        if (this.currentPayment.brand == 'MasterCard') {
          Swal.fire({
            icon: 'error',
            title: 'Tipo de tarjeta no válida',
            text: 'Las suscirpciones solo las puedes realizar con OCA y VISA por el momento.',
            confirmButtonText: 'ACEPTAR',
            didClose: () => { },
          });

          return;
        }

        bodyPurchase = {
          token: this.tokenID,
          subscriptionPlanId: this.objetoPurchase.subscriptionPlanId,
        };

        this.transactionsService.purchaseSuscription(bodyPurchase).subscribe(
          async (resp) => {
            this.cargandoPago = false;
            this.navbarService.cerrarModales();

            if (resp.status === 'OK') {
              this.purchaseID = resp.response.purchaseId;

              // PAGO OK
              if (resp.response.transaction.transactionStatusId === 1) {
                // Validamos la suscription y actualizamos el boton del header
                let account: any = await this.accountService.getAccount();

                if (account.suscription) {
                  Swal.fire({
                    icon: 'success',
                    title: 'BIEN!',
                    text: 'Ahora estás suscripto a +CINEMATECA. Disfrute nuestro contenido!',
                    confirmButtonText: 'ACEPTAR',
                    customClass: { popup: 'payment_sub_success' },
                    didClose: () => {
                      this.router.navigateByUrl('/home');
                    },
                  });
                } else {
                  Swal.fire({
                    icon: 'error',
                    title: 'UPS!',
                    text: 'Ha ocurrido un error en la suscripción. Vuelva a intentarlo en unos minutos.',
                    confirmButtonText: 'ACEPTAR',
                    didClose: () => { },
                  });
                }
              }

              // PAGO PENDIENTE
              if (resp.response.transaction.transactionStatusId === 2) {
                this.openIframeCustomCVV(resp.response.commerceAction.actionURL);
              }

              // PAGO RECHAZADO
              if (resp.response.transaction.transactionStatusId === 4) {
                Swal.fire({
                  icon: 'error',
                  title: 'Compra rechazada',
                  text: 'La compra ha sido rechazada.',
                });
              }
            } else {
              // ERROR EN EL PAGO
              Swal.fire({
                icon: 'error',
                title: 'Hubo un error',
                text: 'Se produjo un error. Intenete nuevamente.',
              });
            }
          },
          (error) => {
            this.cargandoPago = false;
            this.navbarService.cerrarModales();

            Swal.fire({
              icon: 'error',
              title: 'Hubo un error',
              text: 'Se produjo un error. Intente nuevamente.',
            });
          },
        );
      }

      // PAGAR MOVIE
      if (this.typeTransaction == 'movie') {
        bodyPurchase = {
          token: this.tokenID,
          movieId: this.objetoPurchase.movieId,
        };

        this.transactionsService.purchase(bodyPurchase).subscribe(
          (resp) => {
            this.cargandoPago = false;
            this.navbarService.cerrarModales();

            if (resp.status === 'OK') {
              this.purchaseID = resp.response.purchaseId;

              // PAGO OK
              if (resp.response.transaction.transactionStatusId === 1) {
                // PAGO OK
                Swal.fire({
                  icon: 'success',
                  title: 'Pago completado',
                  text: 'El pago se ha efectuado correctamente.',
                  timer: 3000,
                  confirmButtonText: 'REPRODUCIR CONTENIDO',
                  customClass: { popup: 'payment_movie_success' },
                });

                this.router.navigate(['/watch', this.objetoPurchase.movieId]);
              }

              // PAGO PENDIENTE
              if (resp.response.transaction.transactionStatusId === 2) {
                this.openIframeCustomCVV(resp.response.commerceAction.actionURL);
              }

              // PAGO RECHAZADO
              if (resp.response.transaction.transactionStatusId === 4) {
                Swal.fire({
                  icon: 'error',
                  title: 'Compra rechazada',
                  text: 'La compra ha sido rechazada.',
                });
              }
            } else {
              // ERROR EN EL PAGO
              Swal.fire({
                icon: 'error',
                title: 'Hubo un error',
                text: 'Se produjo un error. Intente nuevamente.',
              });
            }
          },
          (error) => {
            this.cargandoPago = false;
            this.navbarService.cerrarModales();

            Swal.fire({
              icon: 'error',
              title: 'Hubo un error',
              text: 'Se produjo un error. Intente nuevamente.',
            });
          },
        );
      }
    }
  }

  seleccionarMedioPago(paymentProfileId: number) {
    this.listaTarjetas.forEach((tarjeta: PaymentProfile) => {
      tarjeta.selected = false;

      if (tarjeta.paymentProfileId == paymentProfileId) {
        tarjeta.selected = true;
        this.tokenID = tarjeta.token;
        this.currentPayment = tarjeta;
      }
    });
  }

  agregarTarjeta() {
    if (this.uniqueID) this.openIframeCustom();
    else this.openIframeNormal();
  }

  ingresarTarjeta() {
    this.openIframeNormal();
  }

  eliminarTarjeta(PaymentProfileId: number) {
    this.cargandoTarjetas = true;

    this.transactionsService.eliminarTarjeta(PaymentProfileId).then((resp: any) => {
      this.cargandoTarjetas = false;

      if (resp.uniqueId) {
        this.cargarTarjetas();
      } else {
        Swal.fire({
          icon: 'error',
          title: 'UPS!',
          text: 'Ha ocurrido un error inesperado. Recargue el navegador e intente nuevamente',
          timer: 1500,
        });
      }
    });
  }

  //#region METODOS Siempre Pago
  loadSiemprePagoJavascript() {
    try {
      var key = '';
      if (this.ppv) key = environment.siemprePago_publicKey;
      else key = environment.siemprePagoNoCVV_publicKey;
      this._pwCheckout
        .loadScript(environment.siemprePago_enviroment, key)
        .then((data) => {
          PWCheckout.SetStyle({
            backgroundColor: 'ffffff',
            buttonColor: '2e6da4',
            buttonHoverColor: '363636',
            buttonTextColor: 'ffffff',
            buttonTextHoverColor: 'ffffff',
            inputBackgroundColor: 'ffffff',
            inputTextColor: '141426',
            inputErrorColor: 'ff0000',
            inputAddonBackgroundColor: 'ffffff',
            labelColor: '494949',
          });

          PWCheckout.SetProperties(this.PWCheckout_Properties);

          PWCheckout.Bind('tokenCreated', this.onTokenCreated.bind(this));
          PWCheckout.Bind('notificationReceived', this.NotificationHandler.bind(this));
        })
        .catch((error) => console.log('ERROR loadJS', error));
    } catch (error) {
    }
  }

  joinErrorsMessages(errors: Error[]) {
    let errorRes: string = '';
    for (const error of errors) {
      errorRes += error.message + '\n';
    }
    return errorRes;
  }

  onTokenCreated(token) {
    this._ngZone.run(() => {
      this.cargarTarjetas(true);

      this.tarjetaSeleccionada = token;
      this.tokenID = token.TokenId;
      this.botonPagoDisabled = false;
    });
  }

  openIframeNormal() {
    PWCheckout.OpenIframeNormal();
  }

  openIframeCustom() {
    let CaptureURL = environment.siemprePago_captureURL;
    var key = '';
    if (this.ppv) key = environment.siemprePago_publicKey;
    else key = environment.siemprePagoNoCVV_publicKey;

    PWCheckout.OpenIframeCustom(`${CaptureURL}?key=${key}&session_id=${this.uniqueID}`, this.uniqueID);
  }

  openIframeCustomCVV(actionURL: string) {
    PWCheckout.PWCapture(actionURL);

    PWCheckout.Bind('notificationReceived', this.NotificationHandler.bind(this));
  }

  CloseHandler(abc) {
    this.cargarTarjetas();
  }

  NotificationHandler(notification) {
    // REQUIERE CVV
    if (notification.ProcessType == 'PURCHASE_PENDING') {
      this.transactionsService.getPurchaseStatus(this.purchaseID).then((resp: PurchaseResponseModel) => {
        // PAGO OK
        if (resp.response.transaction.transactionStatusId === 1) {
          Swal.fire({
            icon: 'success',
            title: 'Pago completado',
            text: 'El pago se ha efectuado correctamente.',
            timer: 1500,
            customClass: { popup: 'payment_generic_success' },
          });

          if (this.objetoPurchase.type == 'movie') this.router.navigate(['/watch', this.objetoPurchase.movieId]);
          if (this.objetoPurchase.type == 'suscription') this.router.navigateByUrl('/home');
        } else {
          // PAGO RECHAZADO
          Swal.fire({
            icon: 'error',
            title: 'Compra rechazada',
            text: 'La compra ha sido rechazada.',
          });
        }
        this.navbarService.cerrarModales();
      });
    }
  }

  //#endregion

  private async cargarTarjetas(seleccionarUltima = false) {
    this.cargandoTarjetas = true;
    if (this.auth.estaAutenticado()) {
      this.transactionsService.obtenerTarjetasDePago(this.ppv).then(
        (res: PaymentInfo) => {
          if (res) {
            this.cargandoTarjetas = false;
            this.uniqueID = res.uniqueId;

            if (res.paymentOptions.length > 0) {
              this.listaTarjetas = res.paymentOptions;

              if (seleccionarUltima) {
                this.seleccionarMedioPago(this.listaTarjetas[this.listaTarjetas.length - 1].paymentProfileId);
              } else {
                this.seleccionarMedioPago(this.listaTarjetas[0].paymentProfileId);
              }

              this.botonPagoDisabled = false;
            } else {
              this.listaTarjetas = [];
              this.tokenID = null;
            }
          } else {
            this.listaTarjetas = [];
            this.listaTarjetas = [];
            this.tokenID = null;
          }
          return res;
        },
        (error) => {
          if (this.uniqueID == null) {
            Swal.fire({
              icon: 'error',
              title: 'UPS!',
              text: 'Ha ocurrido un error inesperado. Vuelva a ingresar e intente nuevamente.',
              confirmButtonText: 'CERRAR SESION',
              didClose: () => {
                this.auth.logout('/login');
              },
            });

          }
          this.cargandoTarjetas = false;
        },
      );
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.info.currentValue) {
      try {
        PWCheckout.prueba = '';
        // console.log('PWCheckout cargó correctamente');
      } catch (e) {
        console.log('Error al cargar PWCheckout, cargando manualmente');
        this.loadSiemprePagoJavascript();
      }
      this.PWCheckout_Properties['amount'] = changes.info.currentValue.price;
      PWCheckout.SetProperties(this.PWCheckout_Properties);
    }
  }

  onSubmit() {

    if (this.info.type == 'movie') {
      this.submitFilmCupon();
    }
    else if (this.info.type == 'subscription') {
      this.submitSubCupon();
    }

  }

  submitFilmCupon() {
    let bodyPurchase: RedeemSuscriptionBody;
    bodyPurchase = {
      couponCode: this.couponForm.get('codigoCupon').value,
      movieId: this.info.movieId
    };
    this.transactionsService.redeemFilmCoupon(bodyPurchase).subscribe(
      async (resp) => {
        if (resp.couponOK) {
          Swal.fire({
            icon: 'success',
            title: 'BIEN!',
            text:
              'Ya podes disfrutar de la pelicula!',
            confirmButtonText: 'ACEPTAR',
            customClass: { popup: 'payment_movie_cupon_success' },
            didClose: () => {
              this.router.navigateByUrl('/watch/' + this.info.movieId);
            },
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Cupon No Válido!',
            text: 'El cupon ingresado no es válido o ya fue usado.',
            confirmButtonText: 'ACEPTAR',
            didClose: () => { },
          });
        }
      },
      (error) => {
        //this.cargandoPago = false;

        Swal.fire({
          icon: 'error',
          title: 'Hubo un error',
          text: 'Se produjo un error. Intente nuevamente.',
        });
      },
    );
  }

  submitSubCupon() {
    let bodyPurchase: RedeemSuscriptionBody;
    bodyPurchase = {
      couponCode: this.couponForm.get('codigoCupon').value,
    };
    this.transactionsService.redeemSuscriptionCoupon(bodyPurchase).subscribe(
      async (resp) => {
        if (resp.couponOK) {
          // Validamos la suscription y actualizamos el boton del header
          let account: any = await this.accountService.getAccount();

          if (account.suscription) {
            Swal.fire({
              icon: 'success',
              title: 'BIEN!',
              text:
                'Ahora estás suscripto a +CINEMATECA en el plan ' +
                resp.plan +
                ' hasta el ' +
                resp.expiration +
                '.\n Disfrute nuestro contenido!',
              confirmButtonText: 'ACEPTAR',
              customClass: { popup: 'payment_sub_cupon_success' },
              didClose: () => {
                this.router.navigateByUrl('/home');
              },
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: 'UPS!',
              text: 'Ha ocurrido un error en la suscripción. Vuelva a intentarlo en unos minutos.',
              confirmButtonText: 'ACEPTAR',
              didClose: () => { },
            });
          }
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Cupon No Válido!',
            text: 'El cupon ingresado no es válido o ya fue usado.',
            confirmButtonText: 'ACEPTAR',
            didClose: () => { },
          });
        }
      },
      (error) => {
        //this.cargandoPago = false;

        Swal.fire({
          icon: 'error',
          title: 'Hubo un error',
          text: 'Se produjo un error. Intente nuevamente.',
        });
      },
    );
  }

}
